import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "/components/core/asset/asset-component";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { fullParagraphConfig } from "components/pages/whats-new/whats-new-first-fold-consts";
import { StyledWhatsNewMobileFirstFoldComponent } from "./whats-new-mobile-first-fold-component.scss";
const WhatsNewMobileFirstFoldComponent = ()=>{
    const { title, body, titleColor, bodyColor } = fullParagraphConfig;
    const FIRST_FOLD_IMAGE_URL = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/mobile_first_fold.png";
    return /*#__PURE__*/ _jsxs(StyledWhatsNewMobileFirstFoldComponent, {
        className: "whats-new-mobile-first-fold",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "asset-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(AssetComponent, {
                        image: {
                            src: FIRST_FOLD_IMAGE_URL
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "dark-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        title: title,
                        titleColor: titleColor
                    }),
                    /*#__PURE__*/ _jsx(Paragraph, {
                        body: body,
                        bodyColor: bodyColor
                    })
                ]
            })
        ]
    });
};
export default WhatsNewMobileFirstFoldComponent;
